
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from 'react';
import Head from "next/head";
import useTranslation from "next-translate/useTranslation";

import CustomerSupport from "../../components/sitePages/CustomerSupport";
import {CUSTOMER_SUPPORT_NAMESPACE} from "../../utils/i18nNameSpaces";

const Index = () => {
  const {t} = useTranslation(CUSTOMER_SUPPORT_NAMESPACE);
  return (
    <>
      <Head>
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.desc")}/>
      </Head>
      <CustomerSupport/>
    </>
  );
};

export default Index;

    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/customer-support/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              
            }))
          }
        }
    }
  